import React, { ReactNode } from "react";
import styled from "styled-components";

export interface GradiantScreenProps {
  children: ReactNode;
  backgroundBottomLayer?: string;
  backgroundTopLayer?: string;
  color?: string;
  paddingTop?: number;
  paddingBottom?: number;
}

export const GradiantScreen = ({
  children,
  backgroundBottomLayer,
  backgroundTopLayer,
  color,
}: GradiantScreenProps): React.JSX.Element => {
  backgroundBottomLayer = backgroundBottomLayer || "hsl(210, 100%, 10%)";
  backgroundTopLayer = backgroundTopLayer || "hsl(205, 80%, 53%)";
  color = color || "white";

  return (
    <StyledGradient
      {...{
        $backgroundBottomLayer: backgroundBottomLayer,
        $backgroundTopLayer: backgroundTopLayer,
        $color: color,
      }}
    >
      {children}
    </StyledGradient>
  );
};

const StyledGradient = styled.div<{
  $backgroundTopLayer: string;
  $backgroundBottomLayer: string;
  $color: string;
}>`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(120deg, ${({ $backgroundTopLayer }) => $backgroundTopLayer}, transparent);
  background-color: ${({ $backgroundBottomLayer }) => $backgroundBottomLayer};
  color: ${({ color }) => color};
`;
